import NlpIntent from './NlpIntent';

export { NlpIntent };



// WEBPACK FOOTER //
// src/modules/screens/settings/NlpIntenet/components/index.js